


$(".top-header-slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 26000,
      },
    },
  ],
});

$(document).ready(function () {
  $(".review-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    autoplay: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 990,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 559,
        settings: { slidesToShow: 1 }
      }
    ]
  });

  $(".prev-btn").click(function () {
    $(".review-slider").slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $(".review-slider").slick("slickNext");
  });

  $(".prev-btn").addClass("slick-disabled");

  $(".review-slider").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll(".left-image .left-slide");
  let currentIndex = 0;
  const delay = 5000; // 5 sec

  if (slides.length > 1) {
    setInterval(() => {
      slides[currentIndex].classList.remove("active");
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add("active");
    }, delay);
  }
});